import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import DonationSettingsSection from "./DonationSettingsSection.vue";
import DonationSettingsCheckboxRow from "./DonationSettingsCheckboxRow.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationSettingsActivationTab',
    props: {
        moduleEnabled: { type: Boolean }
    },
    emits: ["update:moduleEnabled"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DonationSettingsSection, {
                title: _ctx.$t('finance.taxReceipts.settings.module.title'),
                subtitle: _ctx.$t('finance.donationModuleSettings.activation.subtitle'),
                "test-id": "donation-settings-module"
            }, {
                default: _withCtx(() => [
                    _createVNode(DonationSettingsCheckboxRow, {
                        "model-value": __props.moduleEnabled,
                        label: _ctx.$t('finance.taxReceipts.settings.module.label'),
                        "enabled-help": _ctx.$t('finance.taxReceipts.settings.module.enabledHelp'),
                        "disabled-help": _ctx.$t('finance.donationModuleSettings.activation.disabledHelp'),
                        "test-id": "donation-settings-module",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (emit('update:moduleEnabled', $event)))
                    }, null, 8 /* PROPS */, ["model-value", "label", "enabled-help", "disabled-help"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title", "subtitle"]));
        };
    }
});
